import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchChoThanhToan } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatDayMonth, currentDate, convertDate } from "utils/formatDate";
import { ChoVayCombo } from "constants/choVayConst";
import ReactDropdown from "react-dropdown";

export const SearchBarDesktop = ({ onSearch }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchChoThanhToan);

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateState = (field, text) => {
    dispatch(
      updateDataSearchChoThanhToan({
        ...dataSearch,
        [field]: text,
      })
    );
  };
  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
    console.log(evt);
  };
  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.TuNgay === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.TuNgay;
  var dateTo = currentDate();
  if (dataSearch.DenNgay === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.DenNgay;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">
            Mã hợp đồng, họ và tên
          </label>
          <input
            placeholder="Mã hợp đồng, họ và tên"
            type="text"
            className="form-control input-sm"
            value={dataSearch.sSearch}
            onChange={updateTextValue("sSearch")}
          ></input>
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Trạng thái</label>
          <select
            class="form-control input-sm"
            value={dataSearch.sTrangThai}
            onChange={updateTextValue("sTrangThai")}
          >
            <option value="">Tất cả</option>
            <option value="ChuaThucHien">Chưa thanh toán</option>
            <option value="HoanThanh">Đã thanh toán</option>
          </select>
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Loại</label>
          <select
            class="form-control input-sm"
            value={dataSearch.iLoaiChoVay}
            onChange={updateTextValue("iLoaiChoVay")}
          >
            {ChoVayCombo.KieuVayCombo1.map((item, idx) => (
              <option key={"comboBank" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Từ ngày</label>
          <DateTimePicker
            value={dateFrom}
            onChange={onChangeDate("TuNgay")}
            placeholder="Từ ngày"
            name="tuNgay"
            className="form-control input-sm"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Đến ngày</label>
          <DateTimePicker
            value={dateTo}
            onChange={onChangeDate("DenNgay")}
            placeholder="Đến ngày"
            name="dateFrom"
            className="form-control input-sm"
          ></DateTimePicker>
        </div>
        <div className="input-sm-new input-new-10 search-main-new">
          <button
            type="submit"
            className="btn btn-info-new"
            style={{ marginTop: "28px", paddingTop: "7px" }}
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span className="search-label"> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
